import { render, staticRenderFns } from "./FormDateInput.vue?vue&type=template&id=2568480c&"
import script from "./FormDateInput.vue?vue&type=script&lang=ts&"
export * from "./FormDateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports